import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  info: null,
  deals: [],
  totalStats: null,

  isInfoLoading: false,
  isInfoError: false,
  infoError: "",

  isDealsLoading: false,
  isDealsError: false,
  dealsError: "",

  isInfoSaving: false,
  isInfoSaveSuccess: false,

  isAdding: false,
  isAddSuccess: false,

  isUpdating: false,
  isUpdateSuccess: false,

  isRemoving: false,
  isRemoveSuccess: false,

  isRecovering: false,
  isRecoverSuccess: false,

  isManualAdjusting: false,
  isManualAdjustSuccess: false,
};

const linkedinPromotionSlice = createSlice({
  name: "linkedinPromotion",
  initialState: initialState,
  reducers: {
    // ─── Info ────────────────────────────────────────────────────
    getLinkedinInfo: (state) => {
      state.isInfoLoading = true;
      state.info = null;
    },
    getLinkedinInfoSuccess: (state, action) => {
      state.info = action.payload;
      state.isInfoLoading = false;
      state.isInfoError = false;
      state.infoError = "";
    },
    getLinkedinInfoFailed: (state, action) => {
      state.info = null;
      state.isInfoLoading = false;
      state.isInfoError = true;
      state.infoError = action.payload;
    },

    saveLinkedinInfo: (state) => {
      state.isInfoSaving = true;
      state.isInfoSaveSuccess = false;
    },
    saveLinkedinInfoSuccess: (state, action) => {
      state.info = action.payload;
      state.isInfoSaving = false;
      state.isInfoSaveSuccess = true;
    },
    saveLinkedinInfoFailed: (state) => {
      state.isInfoSaving = false;
      state.isInfoSaveSuccess = false;
    },
    saveLinkedinInfoReset: (state) => {
      state.isInfoSaveSuccess = false;
    },

    // ─── Deals ───────────────────────────────────────────────────
    getLinkedinDeals: (state) => {
      state.isDealsLoading = true;
      state.deals = [];
    },
    getLinkedinDealsSuccess: (state, action) => {
      state.deals = action.payload;
      state.isDealsLoading = false;
      state.isDealsError = false;
      state.dealsError = "";
    },
    getLinkedinDealsFailed: (state, action) => {
      state.deals = [];
      state.isDealsLoading = false;
      state.isDealsError = true;
      state.dealsError = action.payload;
    },

    addLinkedinDeal: (state) => {
      state.isAdding = true;
      state.isAddSuccess = false;
    },
    addLinkedinDealSuccess: (state) => {
      state.isAdding = false;
      state.isAddSuccess = true;
    },
    addLinkedinDealFailed: (state) => {
      state.isAdding = false;
      state.isAddSuccess = false;
    },
    addLinkedinDealReset: (state) => {
      state.isAddSuccess = false;
    },

    updateLinkedinDeal: (state) => {
      state.isUpdating = true;
      state.isUpdateSuccess = false;
    },
    updateLinkedinDealSuccess: (state) => {
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateLinkedinDealFailed: (state) => {
      state.isUpdating = false;
      state.isUpdateSuccess = false;
    },
    updateLinkedinDealReset: (state) => {
      state.isUpdateSuccess = false;
    },

    removeLinkedinDeal: (state) => {
      state.isRemoving = true;
      state.isRemoveSuccess = false;
    },
    removeLinkedinDealSuccess: (state) => {
      state.isRemoving = false;
      state.isRemoveSuccess = true;
    },
    removeLinkedinDealFailed: (state) => {
      state.isRemoving = false;
      state.isRemoveSuccess = false;
    },
    removeLinkedinDealReset: (state) => {
      state.isRemoveSuccess = false;
    },

    // ─── Existing ────────────────────────────────────────────────
    recoverLinkedinDeal: (state) => {
      state.isRecovering = true;
      state.isRecoverSuccess = false;
    },
    recoverLinkedinDealSuccess: (state) => {
      state.isRecovering = false;
      state.isRecoverSuccess = true;
    },
    recoverLinkedinDealFailed: (state) => {
      state.isRecovering = false;
      state.isRecoverSuccess = false;
    },
    recoverLinkedinDealReset: (state) => {
      state.isRecoverSuccess = false;
    },

    manualAdjustLinkedinDeal: (state) => {
      state.isManualAdjusting = true;
      state.isManualAdjustSuccess = false;
    },
    manualAdjustLinkedinDealSuccess: (state) => {
      state.isManualAdjusting = false;
      state.isManualAdjustSuccess = true;
    },
    manualAdjustLinkedinDealFailed: (state) => {
      state.isManualAdjusting = false;
      state.isManualAdjustSuccess = false;
    },
    manualAdjustLinkedinDealReset: (state) => {
      state.isManualAdjustSuccess = false;
    },

    getTotalLinkedinStats: (state) => {
      state.isDealsLoading = true;
    },
    getTotalLinkedinStatsSuccess: (state, action) => {
      state.totalStats = action.payload;
      state.isDealsLoading = false;
    },
    getTotalLinkedinStatsFailed: (state, action) => {
      state.totalStats = null;
      state.isDealsLoading = false;
    },
  },
});

export const {
  getLinkedinInfo,
  getLinkedinInfoSuccess,
  getLinkedinInfoFailed,
  saveLinkedinInfo,
  saveLinkedinInfoSuccess,
  saveLinkedinInfoFailed,
  saveLinkedinInfoReset,
  getLinkedinDeals,
  getLinkedinDealsSuccess,
  getLinkedinDealsFailed,
  addLinkedinDeal,
  addLinkedinDealSuccess,
  addLinkedinDealFailed,
  addLinkedinDealReset,
  updateLinkedinDeal,
  updateLinkedinDealSuccess,
  updateLinkedinDealFailed,
  updateLinkedinDealReset,
  removeLinkedinDeal,
  removeLinkedinDealSuccess,
  removeLinkedinDealFailed,
  removeLinkedinDealReset,
  recoverLinkedinDeal,
  recoverLinkedinDealSuccess,
  recoverLinkedinDealFailed,
  recoverLinkedinDealReset,
  manualAdjustLinkedinDeal,
  manualAdjustLinkedinDealSuccess,
  manualAdjustLinkedinDealFailed,
  manualAdjustLinkedinDealReset,
  getTotalLinkedinStats,
  getTotalLinkedinStatsSuccess,
  getTotalLinkedinStatsFailed,
} = linkedinPromotionSlice.actions;

export default linkedinPromotionSlice.reducer;
